import { connect, useDispatch } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UISelect from 'UIComponents/input/UISelect';
import UILink from 'UIComponents/link/UILink';
import { getInboxSettingsUrl } from '../../routing/utils/externalUrls';
import debounce from 'react-utils/debounce';
import { getConnectedForms } from '../../actions/ConnectedFormsActions';
import { formHasTicketFieldObjectType } from '../../reducers/connectedForms';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const parseOptions = rawForms => [...rawForms.map(form => {
  return {
    text: form.name,
    value: form.guid
  };
})];
const SupportFormIdField = ({
  onFieldChange,
  connectedForms,
  readOnly,
  value: supportFormId
}) => {
  const dispatch = useDispatch();
  const handleSupportFormSelectChange = ({
    target: {
      value
    }
  }) => {
    onFieldChange(value);
  };
  const supportFormEnabled = supportFormId !== null;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(UIFormControl, {
        className: "m-top-3",
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "knowledgeContentUI.templateEditor.fields.supportFormSetting.label"
        }),
        tooltip: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "knowledgeContentUI.templateEditor.fields.supportFormSetting.formSelectTooltip_jsx",
          elements: {
            UILink
          },
          options: {
            href: 'https://knowledge.hubspot.com/inbox/connect-channels-to-the-conversations-inbox',
            external: true
          }
        }),
        tooltipPlacement: "left",
        children: /*#__PURE__*/_jsx(UISelect, {
          autoload: false,
          disabled: readOnly,
          cache: false,
          clearable: true,
          "data-testid": "support-form",
          placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "knowledgeContentUI.templateEditor.fields.supportFormSetting.emptyState"
          }),
          noResultsText: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "knowledgeContentUI.templateEditor.fields.supportFormSetting.noResults"
          }),
          onChange: handleSupportFormSelectChange,
          loadOptions: debounce((searchString, callback) => {
            return dispatch(getConnectedForms(searchString)).then(formsResponse => {
              callback(null, {
                options: parseOptions(formsResponse.payload.filter(formHasTicketFieldObjectType))
              });
            }, err => callback(err));
          }, 200),
          options: parseOptions(connectedForms),
          value: supportFormEnabled ? supportFormId : null
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "m-bottom-2 m-top-1",
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "knowledgeContentUI.templateEditor.fields.supportFormSetting.descriptionCreateOrEditForm_jsx",
          elements: {
            Link: ({
              children
            }) => /*#__PURE__*/_jsx(UILink, {
              external: true,
              href: getInboxSettingsUrl(),
              children: children
            })
          }
        })
      })]
    })
  });
};
const mapStateToProps = ({
  connectedForms
}) => {
  return {
    connectedForms
  };
};
export default connect(mapStateToProps, null)(SupportFormIdField);